import { useFormikContext } from 'formik';
import {
  Dropdown,
  DropdownItem,
} from '@quicktools/shared-components/components/core/form/Dropdown';

import { getCategoryName } from '../../../utils/common/category';
import analytics from '../../../services/analytics/index';
import TextLabel from '../TextLabel/TextLabel';
import tooltipStyles from '../tooltipStyles';

import useStyles from './styles';
import { IGenericDropdownProps } from './types';

function GenericDropdown({
  name,
  formProps: props,
  dropdownValues,
  textLabel,
  labelPaddingTop,
  selectedCategory,
  labelPaddingTopMobile,
  information,
  analyticsName,
  tooltipProps,
}: IGenericDropdownProps) {
  const tooltipClasses = tooltipStyles({ tooltipProps });
  const classes = useStyles({ labelPaddingTop, labelPaddingTopMobile });
  const { setFieldValue } = useFormikContext();

  const handleDropDownOpen = () => {
    analytics.textBoxClick({
      text_box_name: analyticsName,
      category_name: getCategoryName(selectedCategory),
      page_path: window.location.pathname,
    });
  };

  return (
    <>
      <TextLabel
        tooltipClassName={tooltipClasses.tooltip}
        arrowClassName={tooltipClasses.tooltipArrow}
        required={false}
        htmlFor={name}
        label={textLabel}
        infoText={information}
      />
      <Dropdown
        onToggle={(open) => open && handleDropDownOpen()}
        name={name}
        svgIconName="collapse-arrow-down-gen"
        className={classes.dropDown}
        buttonClassName={classes.button}
        popoverClassName={classes.popoverClass}
        value={props.values[name]}
        onChange={(value) => {
          setFieldValue(name, value);
        }}
      >
        {dropdownValues.map((item: { title: string; value: string }) => (
          <DropdownItem key={item.value} value={item.value}>
            {item.title}
          </DropdownItem>
        ))}
      </Dropdown>
    </>
  );
}
export default GenericDropdown;
